<template>
    <div class="public">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "public"
    }
</script>

<style scoped>

</style>
